import { render } from "./MetaInfo.vue?vue&type=template&id=97ce164e"
import script from "./MetaInfo.ts?vue&type=script&lang=js&external"
export * from "./MetaInfo.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__